export default "__VITE_ASSET__BMHNruKb__"